import { getStorage } from 'models/Browser';
import { create } from 'zustand';

export const METRIC_SYSTEM = 'METRIC';
export const IMPERIAL_SYSTEM = 'IMPERIAL';

export const UNIT_SYSTEM_STORAGE_KEY = 'unitSystem';

export type UnitSystemTypes = 'IMPERIAL' | 'METRIC';

interface UnitSystem {
  unitSystem: UnitSystemTypes;
  setUnitSystem: (unit: UnitSystemTypes) => void;
}
const initialStates = {
  unitSystem: getStorage(UNIT_SYSTEM_STORAGE_KEY) || METRIC_SYSTEM,
};
export const useUnitSystemStore = create<UnitSystem>((set) => ({
  ...initialStates,
  setUnitSystem: (unit: UnitSystemTypes) => set({ unitSystem: unit }),
}));
